import { render } from "./b2c.vue?vue&type=template&id=032a128f"
import script from "./b2c.vue?vue&type=script&lang=js"
export * from "./b2c.vue?vue&type=script&lang=js"

import "./b2c.vue?vue&type=style&index=0&id=032a128f&lang=css"

import exportComponent from "/Users/nick/programming/udemy_vue/IFA_loud/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__